/**
 * PostHog Feature Flag Keys
 * Central place for all PostHog feature flag constants
 *
 * Usage:
 *   import { FeatureFlagKeys } from '../constants/ff.posthog';
 *   const isEnabled = useFeatureFlag(FeatureFlagKeys.addDailyPayOption);
 */

export const FeatureFlagKeys = {
  addDailyPayOption: 'ARF-1866-add-daily-pay-option',
  credentialingV2: 'TEMP-13770-credentialing-v2',
  enablePermanentJobV2AdminPanel: 'ARF-30-enable-permanent-job-v2-admin-panel',
};
